import { Box, CircularProgress, CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import merge from 'lodash.merge';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import wretch from 'wretch';

import { MAIN_CONTENT_ID } from './constants';
import { IDashboardMeta } from './interfaces';
import themeOptions from './themeOptions';

import Dashboard from './components/Dashboard/Dashboard';
import DashboardContext from './components/Dashboard/DashboardContext';
import Header from './components/Header';

export default function DashboardsLayout() {
  const { slug } = useParams();
  const [dashboardMeta, setDashboardMeta] = useState<
    IDashboardMeta | undefined
  >(undefined);

  const selectedDashboard = slug || dashboardMeta?.tabs[0].slug;

  useEffect(() => {
    wretch('/dashboards')
      .get()
      .json()
      .then((json: any) => {
        setDashboardMeta(json);
      });
  }, []);

  const theme = useMemo(() => {
    return createTheme(merge(themeOptions, dashboardMeta?.theme ?? {}));
  }, [dashboardMeta?.theme]);

  const context = useMemo(() => {
    if (dashboardMeta) {
      return {
        ...dashboardMeta,
        selectedDashboard,
        theme,
      };
    }

    return null;
  }, [dashboardMeta, selectedDashboard, theme]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {dashboardMeta ? (
        <DashboardContext.Provider value={context}>
          <Header />
          <Box component="main" id={MAIN_CONTENT_ID} tabIndex={-1}>
            <Dashboard />
          </Box>
        </DashboardContext.Provider>
      ) : (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            height: '100vh',
            width: '100vw',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </ThemeProvider>
  );
}
